import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransferTemplatesPage, { getDefaultData } from "components/pages/TransferTemplatesPage";
import Classes, { TransferTemplate } from "model";

/**
 * @name CaptureTransferTemplateMain2
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureTransferTemplateMain2(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    let templates = getDefaultData().templates;
    const addedTemplate = TransferTemplate.init({ id: TransferTemplate.nextID(), name: "Sample", fromAccount: "6", toAccount: "5", defaultAmount: "100" });
    templates = [ ...templates, addedTemplate ]

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "addedTemplate" ], addedTemplate)
    .update([ "templateAdded" ], true)
    .update([ "templates" ], templates)
    .submit();

    return <TransferTemplatesPage data={ data } />
}